import './SurveyResultsQuestions.less'

import { ButtonLight } from 'front-end/src/components'
import { formatDateAndTimeShort } from 'front-end/src/utils/dateHelpers'
import React, { FC, useContext } from 'react'

import { t, Trans } from '@lingui/macro'

import Form from '../../../../components/common/form/Form'
import Input from '../../../../components/common/form/input/Input'
import Label from '../../../../components/common/form/label/Label'
import Loader from '../../../../components/common/loader/Loader'
import { Modal } from '../../../../components/common/modal/Modal'
import UserDetail from '../../../../components/common/user/user-detail/UserDetail'
import { SurveyResultsContext } from './SurveyResults'
import { SurveyQuestionWithAnswersFragment } from './SurveyResults.codegen'
import { useSurveyQuestionAnswersQuery } from './SurveyResultsQuestions.codegen'

interface ISurveyResultsDetailModal {
  onHide: () => void
  question: SurveyQuestionWithAnswersFragment
}

export const SurveyResultsDetailModal: FC<ISurveyResultsDetailModal> = ({
  onHide,
  question
}) => {
  const { surveyId } = useContext(SurveyResultsContext)

  const { data, loading } = useSurveyQuestionAnswersQuery({
    variables: {
      surveyId: surveyId,
      questionId: question.id
    }
  })

  const answers = data?.admin?.survey?.question?.answers
  const questionOptions = data?.admin?.survey?.question?.content?.options

  const getAnswerValues = (ids) => {
    const findOptions = (id) =>
      questionOptions
        ?.filter((obj) => obj.id === id)
        .map((obj) => obj.label)
        .join(', ')

    if (typeof ids === 'object') {
      return ids
        .map((id) => {
          return findOptions(id)
        })
        .join(', ')
    }
    if (typeof ids === 'string') {
      return findOptions(ids)
    }
  }

  return (
    <>
      <Modal
        show={true}
        size="SUPERWIDE"
        controls={
          <ButtonLight onClick={() => onHide()}>
            <Trans>Cancel</Trans>
          </ButtonLight>
        }
        header={t`Details about answers`}
        className={'UserInsightResultDetailModal'}
      >
        {loading ? (
          <Loader />
        ) : (
          <Form>
            <Label htmlFor="questionTitle">
              <Trans>Question</Trans>
            </Label>
            <Input
              disabled
              fullWidth
              id="questionTitle"
              value={question.title as string}
            />

            <Label htmlFor="questionResultData">
              <Trans>Answers</Trans>
            </Label>

            <div className="Container">
              <table className="Container__table">
                <thead>
                  <tr>
                    <th className="user">
                      <Trans>Name</Trans>
                    </th>
                    <th>
                      <Trans>Date</Trans>
                    </th>
                    <th className="answer">
                      <Trans>Answer</Trans>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {answers && (
                    <>
                      {answers.map((entry, i) => {
                        return (
                          <tr key={i}>
                            <td className="user">
                              <UserDetail
                                display_name={entry.user.display_name}
                                imageUrl={entry.user.image_url}
                                meta={entry.user.userIdentity}
                                size={'normal'}
                              />
                            </td>
                            <td className="datetime">
                              {formatDateAndTimeShort(entry?.created_at)}
                            </td>
                            <td className="answer">
                              {getAnswerValues(entry.value)}
                            </td>
                          </tr>
                        )
                      })}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </Form>
        )}
      </Modal>
    </>
  )
}
